export default __webpack_public_path__ + "static/live-shopping-image-fa5e8ac2db1b2cdefe8db3faff5974b8.avif";